<template>
    <div>
    	<div class="success">预约成功</div>
    	<van-cell title='姓名' value='client.name'></van-cell>
    	<van-cell title='电话号码' value='client.phone'></van-cell>
    	<van-cell title='就餐时间' value='client.meal_time'></van-cell>
    	<van-cell title='就餐人数' value="client.meal_number+'人'"></van-cell>
    </div>
</template>
<script>
  	export default {
  		data(){
  			return{

  			}
  		}
  	}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/service/BookResult.vue